import { render } from "./ItemIndexMasterBook.vue?vue&type=template&id=31c97a60&scoped=true"
import script from "./ItemIndexMasterBook.vue?vue&type=script&lang=js"
export * from "./ItemIndexMasterBook.vue?vue&type=script&lang=js"

import "./ItemIndexMasterBook.vue?vue&type=style&index=0&id=31c97a60&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-31c97a60"

export default script